<template>
    <Layout>
      <PageHeader :title="title" :items="items" />
  
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="mb-2 float-end">
                <b-button v-b-modal.new-item size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Schedule</b-button>
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                    <label class="d-inline-flex align-items-center">
                      Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(name)="data">
                 {{ data.item.doctor.name }}
                </template>
           
                <template #cell(addedby)="data">
                  {{ data.item.addedby.username }}
                </template>
                <template #cell(actions)="data">
                  <div class="btn-group">
                  <b-button @click="edit(data.item.id,data.item.day,data.item.category,data.item.timefrom,data.item.timeto)" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                  <b-button @click="remove(data.item.id,data.item.doctor.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                  </div>
                </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <b-modal id="new-item" centered title="Add Schedule " title-class="font-18" hide-footer>
          <form @submit.prevent="addItem">
              <div class="form-group mb-2">
              <label>Doctor</label>
              <multiselect v-model="category" label="name" :multiple="true" track-by="id" placeholder="Select Doctor"  :options="doctorspecialty"></multiselect>
              <label>Day</label>
              <b-form-select v-model="day" :options="dayOptions" class="form-control" />

              <label>Time From</label>
              <input v-model="timefrom" type="time"  class="form-control" />
              <label>Time To</label>
              <input v-model="timeto" type="time"  class="form-control" />
              </div>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-item')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>
  
      <b-modal id="edit-item" centered title="Edit Schedule " title-class="font-14" hide-footer>
          <form @submit.prevent="editItem">
              <div class="form-group mb-2">
              <input v-model="id" type="hidden">
             <label> Doctor</label>
             <multiselect v-model="category" label="name" :multiple="true" track-by="id" placeholder="Select Doctor"  :options="doctorspecialty"></multiselect>

              <label>Day</label>
              <b-form-select v-model="day" :options="dayOptions" class="form-control" />
              <label>Time From</label>
              <input v-model="timefrom" type="time"  class="form-control" />
              <label>Time To</label>
              <input v-model="timeto" type="time"  class="form-control" />
             
            </div>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-item')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>
  
      <b-modal id="delete-item" centered title="Delete Doctor Speciality" title-class="font-18" hide-footer>
          <form @submit.prevent="removeItem">
              <input v-model="id" type="hidden">
                Are you sure you want to delete Doctor Schedule for : <b>{{ name }}</b> ?
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-item')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> YES</b-button>
              </div>
          </form>
      </b-modal>
  
    </Layout>
  </template>
  
  <script>
  import axios from "axios";
  import Multiselect from "vue-multiselect";
  import Layout from "../../layouts/main";
  import PageHeader from "@/components/page-header";
  import appConfig from "@/app.config";
  import { schedulesComputed,schedulesMethods } from "@/state/helpers";
  import { doctorSpecialtyMethods, doctorSpecialtyComputed } from "@/state/helpers";

  export default {
    page: {
      title: "Schedule",
      meta: [{ name: "description", content: appConfig.description,},],
    },
    components: {
      Layout,PageHeader,Multiselect
    },
    data() {
      return {
        title: "Schedule",
        items: [ {text: "Dashboard",to: "/",}, {text: "Schedule",active: true, }, ],
        TotalRows: 1,
        currentPage: 1,
        perPage: 10,
        Options: [10, 50, 100, 150, 200],
        filter: null,
        todoFilter: null,
        filterOn: [],
        sortDesc: true,
        isBusy: true,
        fields: [
            { key: 'index', label: '#', visible: true },
            { key: 'id', label: 'ID', visible: false },
            { key: 'name', label: 'Name', visible: true },
            { key: 'date', label: 'Day', visible: true },
            { key: 'timefrom', label: 'Time From', visible: true },
            { key: 'timeto', label: 'Time To', visible: true },
            { key: 'actions', label: 'Actions', visible: true },
          ],
        id:'',
        name:'',
        category:[],
        speciality:'',
        location:'',
        timefrom:'',
        day:'',
        timeto:'',
        dayOptions: [
        { value: "Monday", text: "Monday" },
        { value: "Tuesday", text: "Tuesday" },
        { value: "Wednesday", text: "Wednesday" },
        { value: "Thursday", text: "Thursday" },
        { value: "Friday", text: "Friday" },
        { value: "Saturday", text: "Saturday" },
        { value: "Sunday", text: "Sunday" },
      ],

      };
    },
    computed: {
      ...doctorSpecialtyComputed,
      ...schedulesComputed,
      List() { return this.schedules.length; },
      Fields() { return this.fields.filter(field => field.visible) },
      Items() { return this.schedules.map((d) => ({...d }))},
      IsBusy() { let a=false; if (this.schedules.length>0) { a=false;} else { a=true;} return a },
    },
    mounted() {
      this.fetchSchedules();
      this.fetchDoctorspecialty();
      this.TotalRows = this.schedules.length;
      this.isBusy=false;
    },
    methods: {
      ...doctorSpecialtyMethods,
      ...schedulesMethods,
      Filtered(filteredItems) {
        this.TotalRows = filteredItems.length;
        this.currentPage = 1;
      },
  
  
      edit(id,date,category,timefrom,timeto){
        this.id=id;
        this.date=date;
        this.timefrom=timefrom;
        this.timeto=timeto;
        this.category=category;
        this.$bvModal.show('edit-item')
      },
      remove(id,name){
        this.id=id;
        this.name=name;
        this.$bvModal.show('delete-item')
      },
      
      async addItem() { 
        let formData = new FormData();
        formData.append("timefrom", this.timefrom);
        formData.append("timeto", this.timeto);
        formData.append("day", this.day);
        let categoryIds = '';
        if (this.category) {
          for (let i = 0; i < this.category.length; i++) {
            categoryIds += this.category[i].id;
            if (i < this.category.length - 1) {
              categoryIds += ',';
            }
          }
        }
        formData.append("category", categoryIds);
        let url = "/addschedule";
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchSchedules();
            this.$bvModal.hide('new-item');
            this.name="";
            this.timefrom="";
            this.timeto="";
            this.day="";
        }
        });
      },
      async editItem(){ 
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append('timefrom',this.timefrom);
      formData.append("timeto", this.timeto);
        formData.append("day", this.day);
        let categoryIds = '';
        if (this.category) {
          for (let i = 0; i < this.category.length; i++) {
            categoryIds += this.category[i].id;
            if (i < this.category.length - 1) {
              categoryIds += ',';
            }
          }
        }
        formData.append("category", categoryIds);
      let url = "/updateschedule";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchSchedules();
        this.$bvModal.hide('edit-item');
          this.category="";
          this.timeto="";
          this.timefrom="";
          this.date="";
        }
      });
      },
      async removeItem() { 
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removeschedule";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchSchedules();
        this.$bvModal.hide('delete-item');
        }
      });
      },
    },
  };
  </script>